import { render, staticRenderFns } from "./MetricSummary.vue?vue&type=template&id=13df43c4&scoped=true"
import script from "./MetricSummary.vue?vue&type=script&lang=js"
export * from "./MetricSummary.vue?vue&type=script&lang=js"
import style0 from "./MetricSummary.vue?vue&type=style&index=0&id=13df43c4&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13df43c4",
  null
  
)

export default component.exports